<template>
  <div class="dashboard">
    <div class="banner">
      <el-carousel trigger="click" height="400px">
        <el-carousel-item>
          <img style="height: 400px;margin-left: 50%;transform: translateX(-50%)" src="../../assets/banner1.jpg" alt="">
        </el-carousel-item>
        <el-carousel-item>
          <img style="height: 400px;margin-left: 50%;transform: translateX(-50%)" src="../../assets/banner2.jpg" alt="">
        </el-carousel-item>
        <el-carousel-item>
          <img style="height: 400px;margin-left: 50%;transform: translateX(-50%)" src="../../assets/banner3.jpg" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="news">
      <div class="newsInfo">
        <div class="title">新闻中心</div>
        <div class="newsItem" v-for="news in newsList" :key="news.id">
          <span @click="newsRouter(news)">{{news.title}}</span>
        </div>
        <div class="moreInfo" @click="$router.push({name:'客服知识库'})">更多</div>
      </div>
      <div class="caseInfo">
        <div class="title">案例中心</div>
        <div class="caseWrapper">
          <div>
            <div class="newsItem" v-for="caseItem in caseInfo" :key="caseItem.id">
              <span @click="caseRouter(caseItem)">{{caseItem.title}}</span>
            </div>
          </div>
          <div style="width: 100px">
            <img style="width: 100%" v-lazy="caseImg" alt="">
          </div>
        </div>
        <div class="moreInfo" @click="$router.push({name:'案例展示'})">更多</div>
      </div>
      <div class="productInfo">
        <div class="productTitle">产品中心</div>
        <el-carousel height="165px" width="280px">
          <el-carousel-item v-for="item in productInfo" :key="item.id" @click.native="productRouter(item)">
            <img v-if="item.productImg" style="width: 100%;height:100%;cursor: pointer"
                 v-lazy="'http://file.hoaccu.com/'+item.productImg" :alt="item.productImg">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="specialOfferInfo">
        <div class="title">优惠活动</div>
        <span class="specialInfo" v-html="specialInfo"></span>
        <div class="moreInfo" @click="$router.push({name:'优惠活动'})">更多</div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    getKnowledgeInfo,
    getCompanyOtherInfo,
    getProductInfo,
    getProductImg,
    getCompanybaseInfo
  } from "@/api/hoaccu";

  export default {
    name: "dashboard",
    data() {
      return {
        newsList: [],
        caseInfo: [],
        caseImg: "",
        productInfo: [],
        specialInfo: "",
        dictList:{
          millingMachine:"铣床",
          grindingMachine:"磨床",
          radialDrillingMachine:"摇臂钻床",
          digitalControlledLathe:"数控车床",
        }
      }
    },
    created() {
      //获取客服知识库数据
      this.getKnowledgeData();
      //获取案例展示的信息
      this.getCaseInfo();
      //获取产品展示的信息
      this.getProductData();
      //获取优惠活动的信息
      this.getSpecialInfo();
    },
    methods: {
      productRouter(item){
        if (item.type === 'millingMachine' || item.type === 'grindingMachine' || item.type === 'radialDrillingMachine' || item.type === 'digitalControlledLathe'){
          this.$router.push({
            name:this.dictList[item.type] + '详情',
            params:{
              id:item.id
            }
          })
        }else {

        }
      },
      caseRouter(caseItem){
        this.$router.push({
          name:"案例展示详情",
          params:{
            id:caseItem.id
          }
        })
      },
      newsRouter(news){
        this.$router.push({
          name:"客服知识库详情",
          params:{
            id:news.id
          }
        })
      },
      //获取优惠活动的信息
      getSpecialInfo() {
        getCompanybaseInfo({
          page:1,
          pageSize:1,
          condition:[
            {
              "key":"type",
              "value":"specialOffer"
            }
          ]
        }).then(res=>{
          if (res.status === 200) {
            if (res.data.data.length){
              this.specialInfo = res.data.data[0].content;
              console.log(this.specialInfo);
            }
          } else {
            this.$message.warning(res.message);
          }
        }).catch(err=>{
          this.$message.warning(err.message);
        })
      },
      //获取产品展示的信息
      getProductData() {
        getProductInfo({
          page: 1,
          pageSize: 5,
          condition: []
        }).then(res => {
          if (res.status === 200) {
            this.productInfo = res.data.data;
            this.productInfo.forEach((item, index) => {
              getProductImg({
                page: 1,
                pageSize: 1,
                condition: [
                  {
                    "key": "pid",
                    "value": item.id
                  }
                ]
              }).then(response => {
                if (response.status === 200) {
                  if (response.data.data.length) {
                    this.$set(item, "productImg", response.data.data[0].img);
                  } else {
                    this.productInfo.splice(index, 1)
                  }
                } else {
                  this.$message.warning(response.message);
                }
              })
            });
            console.log(this.productInfo);
          } else {
            this.$message.warning(res.message);
          }
        }).catch(err => {
          this.$message.warning(err.message);
        })
      },
      //获取案例展示的信息
      getCaseInfo() {
        getCompanyOtherInfo({
          page: 1,
          pageSize: 3,
          condition: [
            {
              "key": "type",
              "value": "showCase"
            }
          ]
        }).then(res => {
          if (res.status === 200) {
            this.caseInfo = res.data.data;
            if (this.caseInfo.length) {
              this.caseImg = "http://file.hoaccu.com/" + this.caseInfo[0].coverImg;
            }
          } else {
            this.$message.warning(res.message);
          }
        }).catch(err => {
          this.$message.warning(err.message);
        })
      },
      //获取客服知识库的信息
      getKnowledgeData() {
        getKnowledgeInfo({
          page: 1,
          pageSize: 4,
          condition: []
        }).then(res => {
          if (res.status === 200) {
            this.newsList = res.data.data;
          } else {
            this.$message.warning(res.message);
          }
        }).catch(err => {
          this.$message.warning(err.message);
        })
      },
    }
  }
</script>

<style scoped lang="less">
  .dashboard {


    .news {
      width: 1200px;
      margin: 30px auto 40px auto;
      display: flex;
      justify-content: space-around;

      .newsInfo {
        padding: 5px 10px;
        border: 1px solid #ccc;
        width: 270px;
        background: #fff;
        height: 168px;
        position: relative;

        .newsItem {
          margin-bottom: 15px;
          font-size: 12px;
          font-weight: 600;
          color: #666;
          line-height: 16px;
          cursor: pointer;
          user-select: none;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 240px;

          &:hover {
            color: #e60012;
          }

          &:before {
            content: "";
            display: inline-block;
            width: 2px;
            height: 14px;
            background: #e60012;
            position: relative;
            left: 0;
            top: 2px;
            margin-right: 5px;
          }
        }

        .moreInfo {
          position: absolute;
          right: 10px;
          bottom: 10px;
          font-size: 12px;
          font-weight: bold;
          color: #e60012;
          cursor: pointer;
        }
      }

      .caseInfo {
        background-image: url("../../assets/case_bg.jpg");
        padding: 5px 10px;
        border: 1px solid #ccc;
        width: 280px;
        height: 168px;
        position: relative;

        .caseWrapper {
          display: flex;
        }

        .newsItem {
          width: 150px;
          margin-bottom: 15px;
          font-size: 12px;
          font-weight: 600;
          color: #666;
          line-height: 16px;
          cursor: pointer;
          user-select: none;

          &:hover {
            color: #e60012;
          }
        }

        .moreInfo {
          position: absolute;
          right: 10px;
          bottom: 10px;
          font-size: 12px;
          font-weight: bold;
          color: #e60012;
          cursor: pointer;
        }
      }

      .productInfo {
        padding: 5px 10px;
        border: 1px solid #ccc;
        width: 280px;
        background: #fff;
        height: 168px;
        position: relative;

        /deep/ .el-carousel {
          margin: -5px 0 0 -10px;
        }

        /deep/ .el-carousel__indicators, .el-carousel__indicators--horizontal {
          display: none;
        }

        .productTitle {
          position: absolute;
          left: 10px;
          top: 5px;
          color: #e60012;
          font-size: 18px;
          font-weight: bold;
          z-index: 10;
        }
      }

      .specialOfferInfo {
        background-image: url("../../assets/yhhd.jpg");
        padding: 5px 10px;
        border: 1px solid #ccc;
        width: 280px;
        height: 168px;
        position: relative;
        .specialInfo{
          padding: 0 10px;
          font-size: 12px;
          color: #666;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 6;  /*要显示的行数*/
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .moreInfo {
          position: absolute;
          right: 10px;
          bottom: 10px;
          font-size: 12px;
          font-weight: bold;
          color: #e60012;
          cursor: pointer;
        }
      }

      .title {
        color: #e60012;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 10px;
      }
    }

  }
</style>
